import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { olayBildir } from './utils/olayBildir';

// Yakalanmamış ekran hataları Sistem Sağlığı'na (2026-10-12). API hataları zaten axios katmanında bildiriliyor.
window.addEventListener('error', (e) => {
  olayBildir('js_hatasi', { mesaj: String(e?.message || '').slice(0, 300), kaynak: String(e?.filename || '').slice(-120), satir: e?.lineno || null });
});
window.addEventListener('unhandledrejection', (e) => {
  const r = e?.reason;
  if (r?.isAxiosError) return;
  olayBildir('js_promise_hatasi', { mesaj: String(r?.message || r || '').slice(0, 300) });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
  );

// index.html'deki açılış göstergesini kaldır. React mount olana kadar ekran
// beyaz kalıyordu; mobil veride bu bir dakikayı bulup müşteriye "sayfa
// açılmıyor" dedirtiyordu. requestAnimationFrame: ilk boyamayı bekle ki
// gösterge ile içerik arasında boş kare olmasın.
requestAnimationFrame(() => {
  const el = document.getElementById('acilis');
  if (!el) return;
  el.classList.add('gizle');
  setTimeout(() => { try { el.remove(); } catch { /* zaten gitti */ } }, 300);
});
